import { createSlice } from '@reduxjs/toolkit';

import { batchReducer, batchState } from './reducers/_batch';
import { sessionManagerReducer, sessionManagerState } from './session-manager';
import { sourceSettingsReducer, sourceSettingsState } from './source-settings';

/** Process Slice. */
export const processSlice = createSlice({
  name: 'feature_process',
  initialState: {
    ...batchState,
    ...sessionManagerState,
    ...sourceSettingsState,
  },
  reducers: {
    ...batchReducer,
    ...sessionManagerReducer,
    ...sourceSettingsReducer,
  },
});

/** Process Slice Actions. */
export const processSliceActions = processSlice.actions;
